export default __webpack_public_path__ + "c03fbeedeed9a84c8153cf365d2313b1.svg";